import { pricesResponseSelector } from '@/scopes/prices/components/selectors'
import { usePricesSelector } from '@/scopes/prices/infrastructure/usePricesSelector'
import { Banner, SpaceBetween, Typography } from '@sunwebgroup/ui-components'
import { styled } from 'styled-components'

const Texts = styled(SpaceBetween)`
  flex: 1;
`

export function Messages() {
  const { messages } = usePricesSelector(pricesResponseSelector)
  if (!messages)
    return null
  return messages.map((message, index) => (
    <Banner key={index} $type={message.level}>
      <Texts direction="y">
        {message.texts.map((text, _) => (
          <Typography key={_} dangerouslySetInnerHTML={{ __html: text }} />
        ))}
      </Texts>
    </Banner>
  ))
}
